import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import T from 'components/common/text/T';
import { color } from 'styles/utils';
import MuiButton from 'components/common/button/MuiButton';
import CustomSpan from 'components/common/text/CustomSpan';
import { StyledPlainButtonOuter } from 'components/common/styled/Button';
import { appList } from 'lib/mapper';
import { isClinicUserSelector } from 'store/modules/user';
import { useShallowAppSelector } from 'store/hooks';

interface UserPasswordProps {
  onCloseModal: () => void;
}

function SoftwarePathModalContainer({ onCloseModal }: UserPasswordProps) {
  const {
    isClinicUser,
  }: {
    isClinicUser: boolean;
  } = useShallowAppSelector(state => ({
    isClinicUser: isClinicUserSelector(state),
  }));
  const { ipcRenderer } = window;
  const [appListCt, setAppListCt] = useState<Object[]>([]);
  const [appNameListCt, setAppNameListCt] = useState<string[]>([]);

  useEffect(() => {
    const appCodeList: string[] = appList.reduce((acc: string[], curr: any) => {
      return acc.concat(curr.code);
    }, []);
    setAppNameListCt([...appCodeList]);
  }, []);

  const handleOpenDialog = (code: string) => {
    if (ipcRenderer) {
      console.log('HDS] handleOpenDialog');
      ipcRenderer.send('openFile', { directoryType: code });
    }
  };

  useEffect(() => {
    if (!ipcRenderer) return;
    if (appNameListCt.length > 0) {
      console.log('HDS] handleGetDirPath 222222');
      handleGetDirPath([...appNameListCt]);
    }
  }, [appNameListCt]);

  const handleGetDirPath = (appNames: string[]) => {
    console.log('HDS] handleGetDirPath 111111');
    ipcRenderer.send('directoryGet', {
      directoryTypeList: [...appNames],
    });
  };

  useEffect(() => {
    if (ipcRenderer) {
      ipcRenderer.on(
        'openFileRes',
        (e: any, data: { directoryType: string; canceled: boolean; filePaths: string[] }) => {
          if (!!data.canceled) return;
          console.log('HDS] openFileRes ______________ ', data);
          handleDirectoryAdd(data.directoryType, data.filePaths[0]);
        },
      );
    }
  }, []);

  useEffect(() => {
    if (ipcRenderer) {
      ipcRenderer.on('directoryGetRes', (e: any, data: any) => {
        console.log('HDS] directoryGetRes ________', data);
        const findPath = appList.map((appData: any) => {
          const returnVal1 = data.find((item: any) => item.directoryType === appData.code)
            ?.directory?.path;
          const returnVal2 = data.find(
            (item: any) => item.directoryType === appData.code,
          )?.directory;
          console.log('HDS] CODE ____ ', appData.code);

          console.log('HDS] returnVal111111 ____ ', returnVal1);
          console.log('HDS] returnVal222222 ____ ', returnVal2);

          // const returnVal = typeof returnVal2 === 'object' ? returnVal1 : returnVal2;
          const returnVal = returnVal1 || returnVal2;
          console.log('HDS] returnVal ____ ', returnVal);

          return { ...appData, appPath: returnVal };
        }, []);
        console.log('HDS] directoryGetRes ___findPath_____', findPath);

        setAppListCt([...findPath]);
      });
    }

    return () => {
      setAppListCt([]);
    };
  }, []);

  useEffect(() => {
    if (ipcRenderer) {
      ipcRenderer.on(
        'directoryAddRes',
        (e: any, data: { status: boolean; directoryType: string; directory: string }) => {
          // handleGetDirPath([...appNameListCt]);
          console.log('HDS] directoryAddRes ________', data);
          setAppListCt((draft: any) => {
            return draft.reduce((acc: any[], curr: any) => {
              if (curr.code === data.directoryType) {
                curr.appPath = data.directory;
              }
              return acc.concat(curr);
            }, []);
          });
        },
      );
    }
  }, [appNameListCt, appListCt]);

  const handleDirectoryAdd = (directoryType: string, directory: string) => {
    ipcRenderer.send('directoryAdd', { directoryType, directory });
  };

  return (
    <SoftwarePathModal data-component-name="SoftwarePathModal">
      <div className="softwarePathModal__container">
        <div className="softwarePathModal__comment">
          <p>
            <T>SOFTWARE_SETTING_DETAIL</T>
          </p>
        </div>
        <div className="softwarePathModal__table_container">
          <div className="softwarePathModal__table">
            <div className="softwarePathModal__table_header">
              <div className="softwarePathModal__table_row">
                <div className="softwarePathModal__table_cell index"></div>
                <div className="softwarePathModal__table_cell icon">
                  <CustomSpan fontSize={16} fontWeight={500} fontColor="#303030">
                    <T>GLOBAL_APPS</T>
                  </CustomSpan>
                </div>
                <div className="softwarePathModal__table_cell name"></div>
                <div className="softwarePathModal__table_cell path">
                  <CustomSpan fontSize={16} fontWeight={500} fontColor="#303030">
                    <T>INSTALLED_FOLDER</T>
                  </CustomSpan>
                </div>
                <div className="softwarePathModal__table_cell browse"></div>
              </div>
            </div>
            <div className="softwarePathModal__table_body">
              {appListCt.length > 0 &&
                appListCt?.map((item: any, index) => {
                  console.log('HDS] appListCt _______ ', item);
                  if (item.code === 'APP_BASEAPP') return;
                  if (item.code === 'APP_MOTIONAPP') return;
                  // return;
                  // if (!!isClinicUser && item.code === 'APP_SCAN_MODEL_SCANNER') return;
                  return (
                    <div className="softwarePathModal__table_row" key={index}>
                      <div className="softwarePathModal__table_cell index"></div>
                      <div className="softwarePathModal__table_cell icon">
                        {!!item.icon ? (
                          <img className="icon_image" src={item.icon} alt={`image: ${item.name}`} />
                        ) : (
                          <div className="icon_default"></div>
                        )}
                      </div>
                      <div className="softwarePathModal__table_cell name">
                        <CustomSpan fontSize={16} fontWeight={500} fontColor="#303030">
                          {item.name}
                        </CustomSpan>
                      </div>
                      <div className="softwarePathModal__table_cell path">
                        <p>{!!item.appPath ? item.appPath : '-'}</p>
                      </div>
                      <div className="softwarePathModal__table_cell browse">
                        <MuiButton
                          className="softwarePathModal__setting_software"
                          variant="contained"
                          color="default"
                          disableElevation
                          onClick={() => {
                            handleOpenDialog(item.code);
                          }}
                        >
                          <CustomSpan fontSize={11} fontWeight={400}>
                            <T>GLOBAL_BROWSE</T>
                          </CustomSpan>
                        </MuiButton>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
        <StyledPlainButtonOuter
          backgroundColor={color.navy_blue}
          left="50%"
          width={370}
          height={76}
        >
          <MuiButton
            type="submit"
            config={{
              width: '320px',
            }}
            // disabled={isDataValid}
            // disabled={!selectedProductSerial.value && !errorSerial.value}
            disableElevation
            color="primary"
            variant="contained"
            disablebackground="#17288a"
            disablefontcolor="#ffffff"
            className="xl border-radius-round productModal__submit_btn"
            onClick={() => {
              // handleRegistration();
              onCloseModal();
            }}
          >
            <T>GLOBAL_OK</T>
          </MuiButton>
        </StyledPlainButtonOuter>
      </div>
    </SoftwarePathModal>
  );
}
const SoftwarePathModal = styled.section<{}>`
  .softwarePathModal__container {
    width: 100%;
    border-radius: 15px;
    padding: 50px 30px 38px;
    background-color: #ffffff;
    position: relative;
    .softwarePathModal__comment {
      margin-bottom: 50px;
      p {
        font-size: 19px;
        font-weight: 700;
        color: #303030;
      }
    }
    .softwarePathModal__table_container {
      .softwarePathModal__table {
        .softwarePathModal__table_header {
          .softwarePathModal__table_row {
            height: 40px;
            background-color: #f4f5fa;
            border-radius: 5px;
            .softwarePathModal__table_cell {
              padding-left: 10px;
              /* height: 100%;
              display: flex;
              align-items: center; */
            }
          }
        }
        .softwarePathModal__table_body {
          height: 570px;
          overflow-y: overlay;
          margin-right: -16px;
          .softwarePathModal__table_row {
            min-height: 70px;
            .softwarePathModal__table_cell {
              min-height: 70px;
              padding: 10px 0;
              &.name {
                font-size: 16px;
              }
              &.path {
                padding-left: 15px;

                /* height: 50px; */
                height: 100%;
                display: flex;
                align-items: center;
                p {
                  /* min-height: 50px; */
                  font-size: 12px;
                  font-weight: 400;
                  color: #303030;
                  word-break: break-all;
                  /* overflow-y: overlay; */
                }
              }
            }
          }
        }
        .softwarePathModal__table_row {
          display: flex;
          align-items: center;
          border-bottom: 1px solid #e7e8f2;
          .softwarePathModal__table_cell {
            display: flex;
            align-items: center;
            &.index {
              width: 30px;
            }
            &.icon {
              width: 90px;
              .icon_default {
                width: 43px;
                height: 43px;
                background-color: #f4f7fa;
                border-radius: 5px;
              }
              .icon_image {
                overflow: hidden;
                width: 43px;
                height: 43px;
              }
            }

            &.name {
              width: 200px;
            }
            &.path {
              width: 720px;
            }
            &.browse {
              width: 160px;
            }
          }
        }

        .softwarePathModal__setting_software {
          width: 140px;
          height: 30px;
          margin: 0 10px;
        }
      }
    }
  }
`;
export default React.memo(SoftwarePathModalContainer);
